/** Gate and status colours shared by the contractor board and the contractor page. */

export const GATE_PILL: Record<string, string> = {
  Green: "bg-green-50 text-status-green", Amber: "bg-amber-50 text-status-amber", Red: "bg-red-50 text-status-red",
};
export const STATUS_PILL: Record<string, string> = {
  Active: "bg-green-50 text-status-green", Expiring: "bg-amber-50 text-status-amber", Expired: "bg-red-50 text-status-red",
  Draft: "bg-brand-grey-light text-brand-charcoal", Closed: "bg-brand-grey-light text-brand-grey",
};
